import request from '@shared/utils/request'

export function listByPipeScope(data) {
  return request({
    url: '/gis-water-om/line/listByPipeScope',
    method: 'post',
    data
  })
}
/** 获取地图元素code by laber */
export function getElementCategoryMap() {
  return request({
    url: '/gis-dict/getElementCategoryMap',
    method: 'post'
  })
}
export function PointlistByPipeScope(data) {
  return request({
    url: '/gis-water-om/point/listByPipeScope',
    method: 'post',
    data
  })
}
export function getAreaList(data) {
  return request({
    url: '/gis-area-scope/allList',
    method: 'post',
    data
  })
}
export function listByAliasId(params) {
  return request({
    url: '/gis-water-om/listByAliasId',
    method: 'post',
    params
  })
}
